import React from 'react';
import Icon from '../../../components/AppIcon';


const ExclusiveContent = ({ userType }) => {
  const content = {
    partner: [
      {
        id: 1,
        title: 'African Football Market Analysis 2026',
        description: 'Comprehensive report on emerging talent markets across West and East Africa with transfer value projections and club partnership opportunities.',
        type: 'Report',
        date: 'January 25, 2026',
        icon: 'FileText',
        badge: 'New',
        badgeColor: 'success'
      },
      {
        id: 2,
        title: 'Priority Player Recommendations',
        description: 'Curated list of 15 elite players matching your club requirements with detailed performance analytics and availability status.',
        type: 'Exclusive',
        date: 'January 24, 2026',
        icon: 'Star',
        badge: 'Premium',
        badgeColor: 'accent'
      },
      {
        id: 3,
        title: 'Transfer Window Strategy Guide',
        description: 'Expert insights on navigating the January 2026 transfer window with FIFA compliance guidelines and negotiation best practices.',
        type: 'Guide',
        date: 'January 20, 2026',
        icon: 'BookOpen',
        badge: null,
        badgeColor: null
      }
    ],
    player: [
      {
        id: 1,
        title: 'European Adaptation Masterclass',
        description: 'Comprehensive video series covering cultural adaptation, language basics, and professional expectations in European football.',
        type: 'Course',
        date: 'January 26, 2026',
        icon: 'Video',
        badge: 'New',
        badgeColor: 'success'
      },
      {
        id: 2,
        title: 'Performance Enhancement Program',
        description: 'Personalized training plan designed by UEFA-certified coaches to elevate your technical skills and tactical awareness.',
        type: 'Training',
        date: 'January 22, 2026',
        icon: 'Activity',
        badge: 'Active',
        badgeColor: 'primary'
      },
      {
        id: 3,
        title: 'Contract Negotiation Essentials',
        description: 'Educational resource explaining player contracts, agent roles, and your rights in the transfer process.',
        type: 'Guide',
        date: 'January 18, 2026',
        icon: 'FileCheck',
        badge: null,
        badgeColor: null
      }
    ],
    coach: [
      {
        id: 1,
        title: 'European Coaching Standards Overview',
        description: 'Detailed breakdown of coaching expectations, certification requirements, and professional development pathways in European football.',
        type: 'Guide',
        date: 'January 25, 2026',
        icon: 'BookOpen',
        badge: 'New',
        badgeColor: 'success'
      },
      {
        id: 2,
        title: 'Interview Preparation Workshop',
        description: 'Video workshop covering common interview questions, presentation techniques, and cultural considerations for European clubs.',
        type: 'Workshop',
        date: 'January 23, 2026',
        icon: 'Video',
        badge: 'Premium',
        badgeColor: 'accent'
      },
      {
        id: 3,
        title: 'Tactical Analysis Tools',
        description: 'Access to professional analysis software and templates used by top European coaching staff for match preparation.',
        type: 'Resource',
        date: 'January 19, 2026',
        icon: 'Layers',
        badge: null,
        badgeColor: null
      }
    ]
  };

  const currentContent = content?.[userType] || content?.partner;

  const getBadgeColorClass = (color) => {
    const colors = {
      success: 'bg-success/10 text-success',
      accent: 'bg-accent/10 text-accent',
      primary: 'bg-primary/10 text-primary'
    };
    return colors?.[color] || colors?.primary;
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 shadow-card">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-foreground font-headline flex items-center gap-2">
          <Icon name="Lock" size={24} className="text-primary" />
          Exclusive Content
        </h2>
      </div>
      <div className="grid grid-cols-1 gap-4">
        {currentContent?.map((item) => (
          <div
            key={item?.id}
            className="flex items-start gap-4 p-4 rounded-lg border border-border hover:bg-muted hover:border-primary transition-all duration-300 cursor-pointer group"
          >
            <div className={`w-12 h-12 rounded-lg ${item?.color} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
              <Icon name={item?.icon} size={24} />
            </div>
            <div className="flex-1">
              <div className="flex items-start justify-between gap-2 mb-2">
                <p className="text-base font-semibold text-foreground">{item?.title}</p>
                {item?.badge && (
                  <span className="px-2 py-1 bg-primary/10 text-primary text-xs font-semibold rounded">
                    {item?.badge}
                  </span>
                )}
              </div>
              <p className="text-sm text-muted-foreground mb-2">{item?.description}</p>
              <p className="text-xs text-muted-foreground">{item?.date}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExclusiveContent;